import {matchPath, useLocation} from 'react-router-dom';
import {useMemo} from 'react';

export function useQuery() {
    const {search} = useLocation();
    return useMemo(() => {
        const query = {};
        for (const [key, value] of new URLSearchParams(search)) {
            query[key] = value;
        }
        return query;
    }, [search]);
}

export const useMatch = (pattern, options={}) => {
    const url = useLocation();
    if (typeof options.active !== 'undefined') {
        return options.active;
    }
    const [ path, search ] = pattern.split('?');
    if (!matchPath(url.pathname, {path, ...options})) {
        return false;
    }
    if (search) {
        const params = new URLSearchParams(search);
        const currentParams = new URLSearchParams(url.search);
        for (const [key, value] of params.entries()) {
            if (currentParams.get(key) !== value) {
                return false;
            }
        }
    }
    return true;
};
